import { getCurrentCompanyId } from '../utils/auth';

// Mock data fallback for notifications
const mockNotifications = [
  {
    id: 1,
    title: 'Invoice Overdue',
    message: 'Invoice INV-2026-001 is overdue by 5 days',
    type: 'warning',
    read: false,
    createdAt: '2026-01-20T10:00:00Z'
  },
  {
    id: 2,
    title: 'Payment Received',
    message: 'Payment of $3,200 received from Marketing Masters LLC',
    type: 'success',
    read: false,
    createdAt: '2026-01-19T14:30:00Z'
  }
];

export const getNotifications = async (userId = 1) => {
  try {
    // For now, return mock data since notification API might not be available
    console.log('Getting notifications for user:', userId);
    return mockNotifications;
  } catch (error) {
    console.error('Error in getNotifications, using mock data:', error);
    return mockNotifications;
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    console.log('Marking notification as read:', notificationId);
    return true;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

export const createNotification = async (notificationData) => {
  try {
    console.log('Creating notification:', notificationData);
    return { id: Date.now(), ...notificationData, createdAt: new Date().toISOString() };
  } catch (error) {
    console.error('Error creating notification:', error);
    throw error;
  }
};

export const deleteNotification = async (notificationId) => {
  try {
    console.log('Deleting notification:', notificationId);
    return true;
  } catch (error) {
    console.error('Error deleting notification:', error);
    throw error;
  }
};

export const getOverdueInvoicesAlert = async () => {
  try {
    const companyId = getCurrentCompanyId();
    if (!companyId) {
      return null;
    }
    
    // Check if we should use mock data for development
    const useMockData = import.meta.env.VITE_USE_MOCK_DATA === 'true';
    
    if (useMockData) {
      return {
        id: 'overdue-invoices',
        type: 'warning',
        title: 'Overdue Invoices',
        message: '3 invoices are overdue',
        count: 3,
        action: 'View Invoices',
        path: '/invoices'
      };
    }
    
    // TODO: Replace with actual API call to check for overdue invoices
    // For new companies, return null (no overdue invoices)
    return null;
  } catch (error) {
    console.error('Error getting overdue invoices alert:', error);
    return null;
  }
};

export const getBankReconciliationAlert = async () => {
  try {
    const companyId = getCurrentCompanyId();
    if (!companyId) {
      return null;
    }
    
    // Check if we should use mock data for development
    const useMockData = import.meta.env.VITE_USE_MOCK_DATA === 'true';
    
    if (useMockData) {
      return {
        id: 'bank-reconciliation',
        type: 'info',
        title: 'Bank Reconciliation Pending',
        message: 'January bank statement needs reconciliation',
        action: 'Reconcile Now',
        path: '/bank-reconciliation'
      };
    }
    
    // TODO: Replace with actual API call to check for pending reconciliations
    // For new companies, return null (no pending reconciliations)
    return null;
  } catch (error) {
    console.error('Error getting bank reconciliation alert:', error);
    return null;
  }
};

export const getTaxDeadlineAlert = async () => {
  try {
    const companyId = getCurrentCompanyId();
    if (!companyId) {
      return null;
    }
    
    // Check if we should use mock data for development
    const useMockData = import.meta.env.VITE_USE_MOCK_DATA === 'true';
    
    if (useMockData) {
      return {
        id: 'tax-deadline',
        type: 'warning',
        title: 'Tax Deadline Approaching',
        message: 'Q4 2025 tax filing due in 45 days',
        action: 'Prepare Taxes',
        path: '/tax-management'
      };
    }
    
    // TODO: Replace with actual API call to check for upcoming tax deadlines
    // For new companies, return null (no immediate tax deadlines)
    return null;
  } catch (error) {
    console.error('Error getting tax deadline alert:', error);
    return null;
  }
};

export const getDashboardNotifications = async () => {
  try {
    const [overdueAlert, reconciliationAlert, taxAlert] = await Promise.all([
      getOverdueInvoicesAlert(),
      getBankReconciliationAlert(),
      getTaxDeadlineAlert()
    ]);

    return [overdueAlert, reconciliationAlert, taxAlert].filter(Boolean);
  } catch (error) {
    console.error('Error getting dashboard notifications:', error);
    return [];
  }
};